import React from 'react';
import { Translation } from '../translations';
import { useToast } from '../context/ToastContext';

interface CTASectionProps {
  t: Translation;
}

const CTASection: React.FC<CTASectionProps> = ({ t }) => {
  const { showToast } = useToast();
  
  const handleSignup = (e: React.MouseEvent) => {
    e.preventDefault();
    const isKorean = t.cta.title.includes('함께') || t.cta.title.includes('시작');
    showToast(isKorean ? '🔨 준비 중입니다' : '🔨 Coming Soon');
  };
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          {t.cta.title}
        </h2>
        <p className="text-xl text-gray-600 mb-8">
          {t.cta.subtitle}
        </p>
        <a 
          href="#" 
          onClick={handleSignup}
          className="inline-block px-8 py-4 gradient-primary text-white rounded-lg text-lg font-semibold hover:shadow-xl transition transform hover:-translate-y-1 cursor-pointer"
        >
          {t.cta.button}
        </a>
        <p className="mt-4 text-sm text-gray-500">
          {t.cta.note}
        </p>
      </div>
    </section>
  );
};

export default CTASection;